<template>
  <div class="d-flex justify-content-between align-items-center item ml-3 mb-3">
    <div class="d-flex align-items-center">
      <img height="35" width="35" class="round mr-3 img-fluid"
           :src="user.imagePath || require('../../../assets/images/avatar.png')">
      <div class="mr-2">
        <div><b>{{user.firstName +' '+ user.lastName}}</b></div>
        <span class="text-primary">{{ user.cellPhoneNumber}}</span>
      </div>
    </div>
    <div>
      <feather-icon class="cursor-pointer text-danger ml-3" @click="$emit('remove',user.id)" icon="XIcon"
                    svgClasses="w-5 h-5 stroke-current"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserMsgCard",
    props: {
      user: [Object]
    }
  }
</script>

<style scoped>
  .item {
    padding: 5px 10px;
    background-color: #f4f4f4;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
  }
</style>
